import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  // Button,
  FormLayout,
  Toast,
  EmptyState,
  Select,
  // Checkbox,Popover,ActionList,ExceptionList,Badge,Modal
  TextField,
  Text,
  BlockStack,
  Banner
} from "@shopify/polaris";

import { 
  reqGetPackageDetail, reqPostAddShoppingCart
} from '../../../../../api';
import utils from '../../../../../utils/utils'
import intl from '../../../../../i18n/intl';
import ImageGalleryShow from '../../../../../components/ImageGalleryShow';

import './index.css';

class PackageDetail extends Component {

  state = {
    //页面动作
    loadingPage: true,

    // 数据
    pageData: '',
    options: [],
    search_product_id: 0,  // 要查询的产品详情的产品ID
    addLoading: false,

    disableAddToCart: true,
    addToCartLoading: false,
    // 选中添加购物车的sku信息
    addCartItem: {
      id: 0,
      vid: 0
    },
    min_quantity: 10,
    set_quantity: 10,
  };

  //进入页面调用接口
  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    let id = params.get("filter");
    if(id){
      this.setState({
        search_product_id: id,
      },()=>{
        this.getPageData();

        // 清除浏览器链接上的参数
      //   try {
      //     var currentUrl = window.location.href;
      //     if (currentUrl.indexOf("?") !== -1) {
      //       currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, '');
      //       if (!!(window.history && window.history.pushState)){
      //         window.history.pushState({}, 0, currentUrl);
      //       } 
      //     }
      //   } catch (error) {
      //     // console.warn(error);
      //   }
      })

    } else {
      this.getPageData();
    }
  }

  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  // 获取列表数据
  getPageData = async() =>{
    this.setState({
      loadingPage: true,
    });
    const params = {
      id:this.state.search_product_id
    };
    const response = await reqGetPackageDetail(params);
    if(response.code==='200'){
      this.setState({
        loadingPage: false,
        pageData: response.data,
        options: response.data.options,
        min_quantity: response.data.number,
        set_quantity: response.data.number,
      });

    }else{
      this.setState({
        loadingPage: false,
        pageData: '',
      });
      // this.toggleToast(response.msg,true);
    }
  }

  // option 选择
  handleChangeOptionSelect = (optionKey,value) => {
    let data = this.state.options;
    // option 选中赋值
    data[optionKey].selected = value;

    let isDisable = true;
    let selectCount = 0;
    let selectVariantTitleArr = [];

    for (let index = 0; index < data.length; index++) {
      if (data[index].selected) {
        selectCount++;
        selectVariantTitleArr.push(data[index].selected);
      }
    }

    // 全部选项都选择好了，并匹配到sku的ID，允许点击添加购物车按钮
    let setAddItem = this.state.addCartItem;

    if (data.length === selectCount) {
      let pageData = this.state.pageData;
      let variantTitleData = pageData.variantTitle;
      // 选择的属性拼接起来
      let singleVariantTitle = selectVariantTitleArr.join('-');

      // 获取需要加入购物车的变体ID
      if (variantTitleData[singleVariantTitle]) {
        setAddItem.id = pageData.id;
        setAddItem.vid = variantTitleData[singleVariantTitle];
        isDisable = false;
      }
    }

    this.setState({
      options: data,
      addCartItem: setAddItem,
      disableAddToCart: isDisable
    })
  }

  // 设置购买数量
  handleInputChange = (value,field) => {
    // 不能小于起订量
    value = (Number(value) < this.state.min_quantity) ? this.state.min_quantity : value;

    this.setState({
      [field]: value
    });
  }

  // 添加产品到购物车
  handleAddToShoppingCart = async() => {
    if (!this.state.disableAddToCart) {
      let data = this.state.addCartItem;
      let pageData = this.state.pageData;

      if (!data.id || !data.vid) {
        this.toggleToast('Something wrong', true);
      }

      // 设置购买数量
      data.quantity = this.state.set_quantity;
      
      this.setState({addToCartLoading: true});
      const params = {
        id: pageData.id,
        cart: JSON.stringify(data),
        type: 'gift',
      }

      const response = await reqPostAddShoppingCart(params)
      this.setState({ addToCartLoading: false });

      if(response.code === '200'){
        this.toggleToast('Added successfully', false);
        // 回调更新悬浮购物车按钮
        if (response.data !== 0) {
          this.props.callBackFun({number: response.data.number });
        }
      }else{
        this.toggleToast(response.msg);
      }
    }
  }

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} duration={1500} /> : null;
    const {
      pageData,options,
      // disableAddToCart,addToCartLoading,
      set_quantity
    } = this.state;

    const initSkeletonPage = (
      <div>
    <Page>
    <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
      </Page>
      </div>
    )

    const EmptyProductList = (
      <div>
        <EmptyState
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>{intl.get("Get no detail")}</p>
        </EmptyState>
      </div>
    );

    let optionsList = '';
    let optionsListSelect = '';
    if (options.length > 0) {
      // optionsList = options.map((item,key) => {
      //   let valueList = item.value.map((it,key1) =>{
      //     return (
      //       <Badge key={key1}>{it}</Badge>
      //     )
      //   });

      //   return (
      //     <div className="Product__Attributes" key={key}>
      //       <div className="Product__Attributes_Name">{item.name}</div>
      //       <div className="Product__Attributes_Content">
      //         {valueList}
      //       </div>
      //     </div>
      //   )
      // });

      optionsListSelect = options.map((it,kk) => {
        return (
          <div className="Product__Attributes" key={kk}>
            <div className="Product__Attributes_Name options">{it.name}</div>
            <div className="Product__Attributes_Content">
              <Select
                label={it.name}
                labelHidden
                placeholder={'Select'}
                options={it.value}
                onChange={(value) => this.handleChangeOptionSelect(kk,value)}
                value={it.selected}
              />
            </div>
          </div>
        )
      });
    }
  
    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <section>
        <Page 
          backAction={{content: 'Branding', onAction: () =>{
            utils.routeListen('/admin/customService/custom-packaging')
            utils.routeJump(this,'/admin/customService/custom-packaging')
            }}}
          title={intl.get('Branding')}
        >
          <Layout>
            <Layout.Section>
             
              <div style={{"paddingTop":"10px"}}></div> 
              {(this.state.pageData === '') ? (
                <Card>
                  {EmptyProductList}
                </Card>
              ) : (
                <section style={{height:'700px'}}>
                  <BlockStack gap={400}>
                  <div>
              <Banner title="Notice">
              <p>Due to system upgrades, purchasing is currently unavailable. If you have any questions, please contact our online customer service!</p>
            </Banner>
              </div>
                  <Card>
                  
                      <section className="Product_Detail_Content">

                        <div className="Product_Detail_Img">
                          {/* <img src={(pageData.image_url === '') ? '/default_image.png' : pageData.image_url} alt="" /> */}
                          <ImageGalleryShow images={pageData.image_list} showThumbnails={true} isshowFullscreenButton={true}/>
                        </div>

                        <div className="Product_Detail_Box detail">
                          <FormLayout>
                            <Text variant="headingMd" as="h2">{pageData.title}</Text>
                            
                            <div className="Product__Attributes">
                              <div className="Product__Attributes_Name">
                              {intl.get('Cost')}
                              </div>
                              <div className="Product__Attributes_Content">
                                {'US ' + pageData.price + ' USD'}
                              </div>
                            </div>

                            {/* 属性列表 */}
                            {optionsList}

                            {/* 属性列表选择 */}
                            {optionsListSelect}
                            
                            <div className="Product__Attributes">
                            <div className="Product__Attributes_Name">
                            {intl.get('Quantity')}
                              </div>
                              <div className="Product__Attributes_Content quantity">
                                <TextField
                                  id="set_quantity"
                                  label=""
                                  type="number"
                                  value={String(set_quantity)}
                                  min={pageData.number}
                                  onChange={this.handleInputChange}
                                  autoComplete="off"
                                />
                              </div>
                            </div>

                            {/* <div style={{display:'flex',justifyContent:'flex-end'}}>
                              <Button
                                variant='primary'
                                onClick={this.handleAddToShoppingCart}
                                disabled={disableAddToCart}
                                loading={addToCartLoading}
                              >
                                {intl.get('Add to cart')}
                              </Button>
                            </div> */}
                          </FormLayout>
                        </div>
                      </section>
                    
                       
                  </Card>

                  {pageData.description && (
                    <Card>
                         
                        <div dangerouslySetInnerHTML={{__html:pageData.description}}>

                        </div>
                         
                    </Card>
                  )}
                  </BlockStack>
                </section>
              )}
              
            </Layout.Section>
          </Layout>
        </Page>
      </section>
    )

    return (
      <div>
        {/* 页面内容 */}
        {pageContent}
        {toastMarkup}
      </div>
    );
  }
}

export default withRouter(PackageDetail);